import { gql } from '@apollo/client';

// Query to get all flag templates
export const GET_FLAG_TEMPLATES = gql`
  query GetFlagTemplates {
    getFlagTemplates {
      id
      flagValue
      iconName
      backgroundColor
      textColor
      isBuiltIn
      isActive
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

// Query to get active flag templates only
export const GET_ACTIVE_FLAG_TEMPLATES = gql`
  query GetActiveFlagTemplates {
    getActiveFlagTemplates {
      id
      flagValue
      iconName
      backgroundColor
      textColor
      isBuiltIn
      isActive
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

// Query to get a single flag template
export const GET_FLAG_TEMPLATE = gql`
  query GetFlagTemplate($id: ID!) {
    getFlagTemplate(id: $id) {
      id
      flagValue
      iconName
      backgroundColor
      textColor
      isBuiltIn
      isActive
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

// Mutation to create a flag template
export const CREATE_FLAG_TEMPLATE = gql`
  mutation CreateFlagTemplate($input: CreateFlagTemplateInput!) {
    createFlagTemplate(input: $input) {
      id
      flagValue
      iconName
      backgroundColor
      textColor
      isBuiltIn
      isActive
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

// Mutation to update a flag template
export const UPDATE_FLAG_TEMPLATE = gql`
  mutation UpdateFlagTemplate($input: UpdateFlagTemplateInput!) {
    updateFlagTemplate(input: $input) {
      id
      flagValue
      iconName
      backgroundColor
      textColor
      isBuiltIn
      isActive
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

// Mutation to delete a flag template
export const DELETE_FLAG_TEMPLATE = gql`
  mutation DeleteFlagTemplate($input: DeleteFlagTemplateInput!) {
    deleteFlagTemplate(input: $input)
  }
`;



